import React, { createContext, useState, useContext, ReactNode } from 'react';


interface UserCounts {
  pendingDriverCount: number;
 
}

interface UserCountContextValue {
  userCounts: UserCounts;
  updateUserCounts: (counts: UserCounts) => void;
}

export const UserCountContext = createContext<UserCountContextValue | undefined>(undefined);


interface UserCountProviderProps {
  children: ReactNode; 
}


export const UserCountProvider: React.FC<UserCountProviderProps> = ({ children }) => {
  const [userCounts, setUserCounts] = useState<UserCounts>({
    pendingDriverCount: 0,
    // Initialize other counts here if needed
  });

  const updateUserCounts = (counts: UserCounts) => {
    setUserCounts(counts);
  };

  return (
    <UserCountContext.Provider value={{ userCounts, updateUserCounts }}>
      {children}
    </UserCountContext.Provider>
  );
};

export const useUserCount = () => {
  const context = useContext(UserCountContext);
  if (!context) {
    throw new Error('useUserCount must be used within a UserCountProvider');
  }
  return context;
};